import { AnimatePresence, motion } from "framer-motion";
import QRCode from "react-qr-code";
import { X, Copy, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export default function QRModal({ open, onClose, url, card }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 1800);
    } catch {
      toast.error("Couldn't copy link");
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="qr-modal-backdrop"
          className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 p-6 backdrop-blur-2xl"
        >
          <motion.div
            initial={{ scale: 0.9, y: 20, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.95, y: 10, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="crystal relative w-full max-w-sm rounded-3xl p-8"
            data-testid="qr-modal"
          >
            <button
              onClick={onClose}
              data-testid="qr-modal-close-btn"
              className="absolute right-5 top-5 text-white/50 transition-colors hover:text-white"
            >
              <X className="h-5 w-5" />
            </button>

            <span className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/50">
              Scan to connect
            </span>
            <h3 className="font-display mt-2 text-2xl font-medium tracking-tight">{card.name}</h3>

            <div className="mt-6 flex justify-center rounded-2xl bg-white p-6">
              <QRCode value={url || "https://emergent.sh"} size={200} data-testid="qr-code" />
            </div>

            <button
              onClick={copy}
              data-testid="qr-copy-link-btn"
              className="mt-6 flex w-full items-center justify-center gap-2 rounded-full border border-white/20 py-3 text-sm text-white transition-colors hover:bg-white/10"
            >
              {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
              {copied ? "Copied" : "Copy link"}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
